<template>
    <div>
      <button @click="createGutschrift">Create Gutschrift</button>
    </div>
  </template>
  
  <script>
  export default {
    props: ['transactionId'],
    methods: {
      createGutschrift() {
        // Send POST request to create a Gutschrift for this.transactionId
      }
    }
  };
  </script>
  